import { createFileRoute, notFound } from "@tanstack/react-router";

import { workspacesQueries } from "@/api/resources/workspaces/queries";
import PartsPage from "@/components/Part/PartsPage";
import i18n from "@/providers/i18n";
import Icon from "@/utils/icons";

export const Route = createFileRoute("/_auth/workspaces/$workspace_id/inventory/parts/")({
  beforeLoad: () => {
    return {
      breadcrumbs: [
        {
          label: i18n.t("navigation.workspace"),
          icon: <Icon.WORKSPACE />,
          path: "/workspaces/$workspace_id",
        },
        {
          label: i18n.t("navigation.inventory-parts"),
          icon: <Icon.PART />,
        },
      ],
    };
  },
  loader: async ({ context, params: { workspace_id } }) => {
    const currentWorkspace = await context.queryClient.ensureQueryData(workspacesQueries.byId(workspace_id));
    if (!currentWorkspace) throw notFound();
  },
  component: PartsPage,
});
